import { InfinitySpin } from "react-loader-spinner";

export function LoaderFileUpload() {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <InfinitySpin width="200" color="var(--color-mk-primary-bright)" />
    </div>
  );
}
